"use strict";
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootFolder = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var iconTypes_1 = require("../../iconTypes");
var svgIconContainer_1 = require("../../svgIconContainer");
exports.RootFolder = React.forwardRef(function (props, ref) {
    var isLarge = props.size >= iconTypes_1.IconSize.LARGE;
    var pixelGridSize = isLarge ? iconTypes_1.IconSize.LARGE : iconTypes_1.IconSize.STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = { transformOrigin: "center" };
    return (React.createElement(svgIconContainer_1.SVGIconContainer, tslib_1.__assign({ iconName: "root-folder", ref: ref }, props),
        React.createElement("path", { d: isLarge ? "M60 380V240H20C8.9543 240 0 231.0456 0 220V20C0 8.954 8.9543 0 20 0H280C291.046 0 300 8.954 300 20V100H380C391.046 100 400 108.954 400 120V340C400 351 391 360 379.998 360H228.414L194.2102 394C190.6098 397.8 185.6094 400 180.009 400H80.0018C69.0008 400 60 391 60 380zM211.914 320H360V140H300V220C300 231.0458 291.046 240 280 240H100V360H171.6756L211.914 320zM179.9978 199.998H219.998L119.9996 39.998H80.0022L179.9978 199.998z" : "M40 300V200H20C8.9543 200 0 191.0456 0 180V20C0 8.954 8.9543 0 20 0H220C231.046 0 240 8.954 240 20V80H300C311.046 80 320 88.954 320 100V260C320 271 311 280 299.998 280H188.4132L154.2102 314C150.6098 317.8 145.6094 320 140.009 320H60.0018C49.0008 320 40 311 40 300zM171.9144 240H280V120H240V180C240 191.0456 231.046 200 220 200H80V280H131.6756L171.9144 240zM139.9978 160H179.9978L99.9996 40H60.0022L139.9978 160z", fillRule: "evenodd", transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"), style: style })));
});
exports.RootFolder.defaultProps = {
    size: iconTypes_1.IconSize.STANDARD,
};
exports.RootFolder.displayName = "Blueprint5.Icon.RootFolder";
exports.default = exports.RootFolder;
//# sourceMappingURL=root-folder.js.map